import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBatteryLoading: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBatteryLoading"><Path d="M1 5H11.5L5.5 13H11.5L7 19H1V5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M20 19H9.5L15.5 11H9.5L14 5H20V8H23V16H20V19ZM20 14H21V10H20V14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBatteryLoading;
